import { render, staticRenderFns } from "./Pagar.vue?vue&type=template&id=f11ed244&"
import script from "./Pagar.vue?vue&type=script&lang=js&"
export * from "./Pagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports